import { navigate } from "gatsby";
import { replaceWithAbsolutePathForBy } from "../links/replaceWithAbsolutePathForBy";

export const navigateToTheNewWebsite = (to) => navigate(replaceWithAbsolutePathForBy(to))
